import { useAtom } from 'jotai'

// helper functions
import { returnValue } from '@/utils/op-types/helperFunctions'
import StaticContentWrapper from '@/components/optypes/frontend/StaticContentWrapper'

import Classnames from 'classnames'

// store
import {
  isBuilder,
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
} from '@/utils/op-types/store'

const Card = ({ children, cardClick }) => {
  const [builder] = useAtom(isBuilder)
  // manifest settings
  const [opStatic] = useAtom(manifestStatic)
  const [opDesign] = useAtom(manifestDesign)
  const [opBlocks] = useAtom(manifestBlocks)
  // custom page settings
  const [pageStatic] = useAtom(pageContentStatic)
  const [pageDesign] = useAtom(pageContentDesign)
  const [pageBlocks] = useAtom(pageContentBlocks)

  return (
    <div
      // onClick={e => {
      //   if (cardClick) {
      //     cardClick(e)
      //   }
      // }}
      className={Classnames(
        'rounded p-6 shadow-sm hover:shadow-xl focus-within:shadow-xl transition-all focus-within:ring-2 focus-within:ring-gray-600 focus-within:ring-opacity-20 focus:border-transparent'
      )}
      style={{
        backgroundColor: returnValue('cardbgcolor', opDesign, pageDesign),
        color: returnValue('cardtextcolor', opDesign, pageDesign),
        borderColor: returnValue('cardbordercolor', opDesign, pageDesign),
        borderWidth: returnValue('cardbordersize', opDesign, pageDesign),
      }}
    >
      {children}
    </div>
  )
}

export default Card
